const HostComponent = {
  Modal: 'modal',
  Popup: 'popup',
}

Object.freeze(HostComponent)

export { HostComponent }
